import { ReactComponent as DownloadIcon } from "assets/icons/membership/download.svg";
import { Select } from "antd";
import PickTime from "pages/Membership/OrderHistory/components/PickTime";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import * as S from "../style";
import MultiCheckbox from "components/MultiCheckbox";
import ListBrandSelectSearch from "components/ListBrandSelectSearch";
import PremiumTable from "./PremiumTable";
import { downloadPremiumApi, getPremiumListApi } from "api/membership";
import fileDownload from "js-file-download";

type Option = {
  label: string;
  value: string;
};

type TimeType = "WEEK" | "1M" | "DATE";

type FilterType = {
  timeFilter?: TimeType;
  registedStatus?: string[];
  emailReceived?: string[];
  queryType?: "EMAIL" | "PHONE" | "NAME";
  querySearch?: string;
  brandId?: string;
};

const emailReceivedOptions: Option[] = [
  {
    label: "전체",
    value: "ALL",
  },
  {
    label: "Y",
    value: "1",
  },
  {
    label: "N",
    value: "0",
  },
];

const registedStatusOptions: Option[] = [
  // {
  //   label: "전체",
  //   value: "ALL",
  // },
  {
    label: "멤버십 유지",
    value: "RENEWAL",
  },
  {
    label: "만료",
    value: "EXPIRED",
  },
];

const sortOptions = [
  { value: "firstRegistedDate-desc", label: "최초가입일 최신순" },
  { value: "firstRegistedDate-asc", label: "최초가입일 오래된순" },
  { value: "totalPay-desc", label: "진행회차 내림차순" },
  { value: "totalPay-asc", label: "진행회차 오름차순" },
  { value: "lastJoiningDate-desc", label: "최근방문일 오래된순" },
  { value: "lastJoiningDate-asc", label: "최근방문일 최신순" },
];

const PremiumMember: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState<FilterType>({
    timeFilter: "WEEK",
    queryType: "EMAIL",
    querySearch: "",
    registedStatus: registedStatusOptions.map((el: Option) => el.value),
    emailReceived: emailReceivedOptions.map((el: Option) => el.value),
  });
  const [isFilterChanged, setIsFilterChanged] = useState<boolean>(false);
  // const [sort, setSort] = useState<"asc" | "desc">("desc");
  const [dataTable, setDataTable] = useState<any>({
    summary: {},
    data: [],
    totalElement: 0,
  });
  useEffect(() => {
    const registedStatusDefault = registedStatusOptions.every((option) =>
      filter?.registedStatus?.includes(option.value)
    );
    const emailReceivedDefault = emailReceivedOptions.every((option) =>
      filter?.emailReceived?.includes(option.value)
    );

    const isChanged: boolean =
      !!filter.brandId ||
      filter.timeFilter !== "WEEK" ||
      !registedStatusDefault ||
      !emailReceivedDefault ||
      filter.queryType !== "EMAIL" ||
      filter.querySearch !== "";
    setIsFilterChanged(isChanged);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  const defaultFilter = () => {
    const defaultValues: FilterType = {
      brandId: undefined,
      timeFilter: "WEEK",
      queryType: "EMAIL",
      querySearch: "",
      registedStatus: registedStatusOptions.map((el: Option) => el.value),
      emailReceived: emailReceivedOptions.map((el: Option) => el.value),
    };
    setFilter(defaultValues);
    getListPremium(defaultValues);
  };
  const handleSortChange = (value: string) => {
    const [sortType, sortDirect] = value.split("-");
    getListPremium({ sortType, sortDirect });
  };
  // console.log("filter", filter);

  const getListPremium = async (payload?: any) => {
    const { data, error }: any = await getPremiumListApi({
      page: Number(searchParams.get("page")) || 1,
      size: 50,
      ...filter,
      emailReceived: filter.emailReceived?.filter((el: string) => el !== "ALL"),
      ...payload,
    });
    if (error) {
      console.log("error", error);
      return;
    }
    if (data.datas) {
      setDataTable({
        data: data.datas,
        totalElement: data.pageable.totalElement,
      });
    }
  };
  // console.log('dataTable', dataTable);

  const handleFilter = () => {
    getListPremium();
  };

  const handleDownload = async (params?: any) => {
    const resp: any = await downloadPremiumApi(filter ? filter : {});
    if (resp) {
      fileDownload(resp, "member_premium.xlsx");
    }
  };

  useEffect(() => {
    getListPremium();
  }, [searchParams.get("page")]);

  return (
    <S.Normal>
      <S.Filter>
        <div className="line mb">
          <div className="block-left">브랜드명</div>
          <div className="block-right" style={{ maxWidth: "421px" }}>
            <ListBrandSelectSearch
              defaultValue={filter.brandId}
              onChange={(v) => {
                if (v === "clear") {
                  setFilter((prev: FilterType) => ({
                    ...prev,
                    brand: undefined,
                  }));
                } else {
                  setFilter((prev: FilterType) => ({
                    ...prev,
                    brand: v,
                  }));
                }
              }}
            />
          </div>
        </div>
        <div className="line mb">
          <div className="block-left">가입일</div>
          <div className="block-right">
            <PickTime
              defaultTimeType={filter.timeFilter}
              onChange={(t, d) => {
                setFilter((prev: FilterType) => ({
                  ...prev,
                  timeFilter: t,
                  startDate: d?.start,
                  endDate: d?.end,
                }));
              }}
            />
          </div>
        </div>
        <div className="line mb">
          <div className="block-left">가입 상태</div>
          <div className="block-right">
            <MultiCheckbox
              defaultValues={filter.registedStatus}
              options={registedStatusOptions}
              onChange={(v) =>
                setFilter((prev: FilterType) => ({
                  ...prev,
                  registedStatus: v as string[],
                }))
              }
            />
          </div>
        </div>
        <div className="line mb">
          <div className="block-left">마케팅수신</div>
          <div className="block-right">
            <MultiCheckbox
              defaultValues={filter.emailReceived}
              options={emailReceivedOptions}
              onChange={(v) =>
                setFilter((prev: FilterType) => ({
                  ...prev,
                  emailReceived: v,
                }))
              }
            />
          </div>
        </div>
        <div className="line">
          <div className="block-left">상세 조건</div>
          <div className="block-right flex">
            <div className="wr-select">
              <Select
                popupClassName="custom-select-dropdown"
                defaultValue="email"
                value={filter.queryType}
                style={{ width: 125 }}
                onChange={(value) =>
                  setFilter((prev: any) => ({
                    ...prev,
                    queryType: value as "email" | "id",
                  }))
                }
                options={[
                  { value: "EMAIL", label: "이메일계정" },
                  { value: "NAME", label: "이름" },
                  { value: "PHONE", label: "휴대전화번호" },
                ]}
              />
            </div>
            <div className="wr-input">
              <input
                value={filter.querySearch}
                onChange={(e) => {
                  setFilter((prev: any) => ({
                    ...prev,
                    querySearch: e.target.value.trim(),
                  }));
                }}
              />
              {filter?.querySearch && (
                <button
                  onClick={() =>
                    setFilter((prev: any) => ({
                      ...prev,
                      querySearch: "",
                    }))
                  }
                >
                  <CloseOutlined />
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="wr-btn">
          {isFilterChanged && (
            <button
              onClick={() => {
                // setIsFilterChanged(false);
                defaultFilter();
              }}
              className="clear-btn"
            >
              Clear
            </button>
          )}
          <button onClick={handleFilter} className="filter-btn">
            검색
          </button>
        </div>
      </S.Filter>
      <S.Sort>
        <h3>전체 목록 (총 {dataTable.totalElement}건)</h3>
        <div className="sort-download">
          <div className="wr-select">
            <Select
              popupClassName="custom-select-dropdown"
              defaultValue="firstRegistedDate-desc"
              style={{ width: 200 }}
              onChange={handleSortChange}
              options={sortOptions}
            />
          </div>
          <button onClick={handleDownload}>
            <DownloadIcon /> 엑셀 다운로드
          </button>
        </div>
      </S.Sort>
      <PremiumTable
        data={dataTable.data}
        totalElement={dataTable.totalElement}
      />
    </S.Normal>
  );
};

export default PremiumMember;
